import { TopSalesState } from './types'

export const state: TopSalesState = {
  sku: []
}
